import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import parse from 'html-react-parser';
import CtaButton from '../ctaButton/ctaButton';
import styles from './partnerHeader.module.scss';

export default function PartnerHeader({
  lcLogo = {},
  cta = null,
  partnerLogo = null,
  partnerLogoText = '',
  theme = '',
  useSlimHeader = false,
}) {
  const [isShow, setShow] = React.useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.document.documentElement.scrollTop < 25 ||
        window.scrollY < 25
      ) {
        setShow(false);
      } else {
        setShow(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <>
      {/* Gradient bar - 12px */}
      <div className={styles.gradientBar} />

      <header
        className={classNames(styles.header, {
          [styles.headerSlim]: useSlimHeader,
          [styles.dark]: theme === 'blue',
          [styles.light]: theme !== 'blue',
        })}
      >
        <div className={styles.wrapper}>
          <div className={styles.lcLogoContainer}>
            <a href={lcLogo.link}>
              <img
                className={styles.lcLogo}
                src={lcLogo.src}
                alt={lcLogo.alt}
                loading="lazy"
                {...{
                  ...(lcLogo.width && {
                    width: lcLogo.width,
                  }),
                  ...(lcLogo.height && {
                    height: lcLogo.height,
                  }),
                }}
              />
            </a>
          </div>
          {isShow && cta && (
            <div className={styles.ctaContainer}>
              <CtaButton
                aria-label="Read More Reviews "
                label={cta.label}
                variant={cta.variant}
                color={cta.color}
                fullWidth
                className={styles.cta}
                href={cta.link}
              />
            </div>
          )}
          {partnerLogo && (
            <div className={styles.partnerContainer}>
              <div className={styles.partnerLogoText}>
                <p>{parse(partnerLogoText)}</p>
              </div>
              <div className={styles.partnerLogoContainer}>
                <img
                  className={styles.partnerLogo}
                  src={partnerLogo.src}
                  alt={partnerLogo.alt}
                  loading="lazy"
                  {...{
                    ...(partnerLogo.width && {
                      width: partnerLogo.width,
                    }),
                    ...(partnerLogo.height && {
                      height: partnerLogo.height,
                    }),
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </header>
      <div
        className={classNames(styles.contentPadding, {
          [styles.contentPaddingSlim]: useSlimHeader,
        })}
      />
    </>
  );
}

PartnerHeader.propTypes = {
  lcLogo: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
  }),
  cta: PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string,
  }),
  partnerLogoText: PropTypes.string,
  partnerLogo: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
  theme: PropTypes.string,
  useSlimHeader: PropTypes.bool,
};
